import { useCheckPermissions } from '@/modules/auth/hooks/useCheckPermissions';
import type { Permission } from '@/modules/auth/permissions';

interface PermissionGateProps {
  permissions: Permission[];
  children: React.ReactNode;
}

/**
 * Gate that checks if the user has all of the given permissions. Useful when you need to check if the user has all of the given permissions.
 */
export const PermissionsGate = ({
  children,
  permissions,
}: PermissionGateProps) => {
  const hasUserPermission = useCheckPermissions();

  return hasUserPermission(permissions) ? children : null;
};
